import constants from 'common/constants'

import {BULK_DATA_CSV, LOGS_RECORD, TRACK_PROGRESS_BAR} from './ActionTypes/ApiActionTypes'

export const bulkDataCSV = (body, onSuccess, onFailure) => {
  return {
    type: BULK_DATA_CSV,
    payload: {
      apiUrl: constants.api_bulk_upload,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'multipart/form-data',
      header2: {
        'api-key': 'randomAuthKey',
      },
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}

export const trackProgressBar = (onSuccess, onFailure) => {
  return {
    type: TRACK_PROGRESS_BAR,
    payload: {
      apiUrl: constants.api_track_progress_bar,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const addOnboardingLogs = (id, body, onSuccess, onFailure) => {
  return {
    type: LOGS_RECORD,
    payload: {
      apiUrl: constants.api_logs_record(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}
